import { getVideoEmbedUrl, isDirectVideoUrl, type BlockComponentProps } from "./shared"

export function VideoBlock({ content, resolved }: BlockComponentProps) {
  const vUrl = (content?.url as string) ?? ""
  const vCap = (content?.caption as string) ?? ""
  const embedUrl = getVideoEmbedUrl(vUrl)
  // NOS-237: direct video files (Weebly-hosted mp4s from imports) play in a
  // native <video> element — previously these rendered nothing at all.
  const fileUrl = !embedUrl && isDirectVideoUrl(vUrl) ? vUrl : null
  if (!embedUrl && !fileUrl) return null
  const videoSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass} max-w-3xl mx-auto`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8 max-w-3xl mx-auto"
  return (
    <section className={videoSectionClass} style={resolved.sectionStyle}>
      <div className="aspect-video rounded-lg overflow-hidden bg-muted">
        {embedUrl ? (
          <iframe
            src={embedUrl}
            title="Video"
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          // eslint-disable-next-line jsx-a11y/media-has-caption -- source captions unavailable for imported files
          <video controls preload="metadata" className="w-full h-full" src={fileUrl ?? undefined} />
        )}
      </div>
      {vCap && <p className="mt-2 text-sm text-muted-foreground text-center">{vCap}</p>}
    </section>
  )
}
